<template>
  <div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full mb-2">
        <div class="flex">
          <div class="w-full">
            <vs-button
              @click="showFilters = !showFilters"
              class="bg_purple float-right"
            >
              <div class="px-3">
                <feather-icon
                  icon="FilterIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("Filter") }}
              </div>
            </vs-button>
          </div>
        </div>
      </div>
    </div>
    <form v-if="showFilters">
      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <label class="vs-select--label">
            {{ $t("ProductName") }}
          </label>
          <treeselect
            v-model="gridSearchData.productId"
            name="productId"
            :multiple="false"
            :placeholder="$t('Search')"
            :async="true"
            :load-options="loadProducts"
            v-validate="'required'"
          />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col lg:w-1/3 sm:w-1/3 w-full">
          <label class="vs-select--label mb-1">{{ $t("FestivalName") }}</label>
          <v-select
            label="name"
            :options="allFestivals"
            v-model="gridSearchData.categoryId"
            v-validate="{ required: true }"
            :reduce="(x) => x.id"
            dir="rtl"
          >
          </v-select>
        </div>
        <div class="vx-col lg:w-1/3 sm:w-1/3 w-full">
          <label class="vs-select--label datepicker-lb">{{
            $t("FromDate")
          }}</label>

          <date-picker
            v-model="gridSearchData.startClock"
            type="datetime"
            format="jYYYY-jMM-jDD HH:mm:ss"
            display-format="jYYYY-jMM-jDD HH:mm:ss"
            class="date-picker"
            :label="$t('FromDate')"
            :clearable="true"
          />
        </div>
        <div class="vx-col lg:w-1/3 sm:w-1/3 w-full">
          <label class="vs-select--label datepicker-lb">{{
            $t("ToDate")
          }}</label>

          <date-picker
            v-model="gridSearchData.expireClock"
            type="datetime"
            format="jYYYY-jMM-jDD HH:mm:ss"
            display-format="jYYYY-jMM-jDD HH:mm:ss"
            class="date-picker"
            :label="$t('ToDate')"
            :clearable="true"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            type="filled"
            class="float-right"
            @click.prevent="submitFilter()"
            >{{ $t("SubmitFilter") }}</vs-button
          >
          <vs-button
            type="filled"
            class="float-right"
            id="reset-btn"
            @click.prevent="resetForm"
            >{{ $t("ResetFilter") }}</vs-button
          >
        </div>
      </div>
    </form>
    <div class="vx-row mt-6">
      <div class="vx-col w-full mb-base">
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          :columns="[
            { title: $t('DiscountType'), sort: 'DiscountType' },
            { title: $t('ProductName'), sort: 'ProductName' },
            { title: $t('ItemCode'), sort: 'ItemCode' },
            { title: $t('CalculationType'), sort: 'CalculationType' },
            { title: $t('DiscountAmount'), sort: 'DiscountAmount' },
            { title: $t('FromDate'), sort: 'FromDate' },
            { title: $t('ToDate'), sort: 'ToDate' },
            { title: $t('FestivalName'), sort: 'FestivalName' },
          ]"
        >
          <template slot-scope="{ row }">
            <td style="width: 15%">
              <span v-if="row.discountDiscriminator == 'Regular'">
                {{ $t("Basic") }}
              </span>
              <span v-if="row.discountDiscriminator == 'Festival'">
                {{ $t("Festival") }}
              </span>
              <span v-if="row.scheduleType == 0">
                {{ $t("Hourly") }}
              </span>
              <span v-if="row.scheduleType == 1">
                {{ $t("Daily") }}
              </span>
            </td>
            <td style="width: 20%">
              {{ row.product.persianName }}-{{ row.product.warrantyName }}-{{
                row.product.colorName
              }}
            </td>
            <td style="width: 12%">
              {{ row.product.itemCode }}
            </td>
            <td style="width: 8%">
              <span v-if="row.productDiscountType == '1'">
                {{ $t("Percent") }}
              </span>
              <span v-if="row.productDiscountType == '2'">
                {{ $t("quantitative") }}
              </span>
            </td>

            <td style="width: 10%">
              <span v-if="row.productDiscountType == '1'"
                >{{ row.discountAmount }}درصد</span
              >
              <span v-if="row.productDiscountType == '2'"
                >{{ Number(row.discountAmount).toLocaleString() }}ریال</span
              >
            </td>
            <td style="width: 12%; direction: ltr">
              {{ row.startClock }}
            </td>
            <td style="width: 12%; direction: ltr">
              {{ row.expireClock }}
            </td>
            <td style="width: 10%">
              <span v-if="row.festivalCategory != null">
                {{ row.festivalCategory.name }}
              </span>
              <span v-else>-</span>
            </td>
          </template>
        </data-grid>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}

.vs-select--label {
  display: block;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
const dict = {
  custom: {
    festival: {
      required: "لطفا عنوان جشنواره را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "saleManagement_Contract_Management_Discounts_ArchiveDiscounts",
  data() {
    return {
      // gridDataSource: {},
      // gridSearchData: {},
      gridDataSource: {
        type: "app",
        service: "Promotion/api/ProductDiscounts",
      },
      gridSearchData: {
        isActive: false,
        contractId: this.$route.params.id,
      },
      contractId: this.$route.params.id,
      showFilters: false,
      searchQueryNew: "",
      searchQueryOld: "",
    };
  },
  components: {
    datePicker: VuePersianDatetimePicker,
    "v-select": vSelect,
    Treeselect,
    DataGrid,
  },
  computed: {
    ...mapGetters({
      allFestivals: "festival/list",
    }),
  },
  methods: {
    ...mapActions({
      fetchFestivals: "festival/fetch",
      searchContractProducts: "sale/searchContractProducts",
    }),
    loadProducts({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.searchContractProducts({
              id: this.contractId,
              name: searchQuery,
            }).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.productId,
                  label: element.persianName,
                  name: element.persianName,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    submitFilter() {
      if (
        this.gridSearchData.startClock == this.gridSearchData.expireClock ||
        this.gridSearchData.startClock < this.gridSearchData.expireClock ||
        (this.gridSearchData.startClock != "" &&
          this.gridSearchData.expireClock == "")
      ) {
        this.gridSearchData = {
          ...this.gridSearchData,
          contractId: this.$route.params.id,
          // categoryId: null,
          // startClock: "",
          // expireClock: "",
        };
        this.$refs.grid.renderGrid();
      } else {
        this.$swal({
          position: "center-center",
          type: "error",
          text: "در انتخاب تاریخ ورودی و خروجی دقت نمایید!",
          showConfirmButton: false,
          timer: 8000,
        });
      }
    },
    resetForm() {
      this.gridSearchData = {};
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
